<template>
	<div class="swiper-container" ref="swiper" :style="{height:height+'px'}">
		<div class="swiper-wrapper">
			<slot name="slide"></slot>
			<div class="swiper-slide" v-if="!!data" v-for="(item,index) in swiperData">{{item.name}}</div>
		</div>
		<!-- Add Pagination -->
		<div class="swiper-pagination"></div>
		<slot name="prev"></slot>
		<slot name="next"></slot>
		<div class="swiper-button-prev" v-show="!!showArrow"></div>
		<div class="swiper-button-next" v-show="!!showArrow"></div>
	</div>
</template>
<script>
	import Swiper from 'swiper'
	export default {
		props: {
			data: Array,
			height: String, 
			direction: {
				type: String,
				default: "horizontal"
			},
			autoPlay: {
				type: String,
			},
			pv: {
				type: Number,
				default: 1
			},
			st: {
				type: Number,
				default: 0
			},
			pg: {
				type: Number,
				default: 1
			},
			effect: {
				type: String,
				default: "slide"
			},
			mouse: {
				type: Boolean,
				default: false
			},
			keyboard: {
				type: Boolean,
				default: false
			},
			showArrow: Boolean
		},
		data() {
			return {
				slidesPerView: this.pv,
				slidesPerGroup: this.pg,
				spaceBetween: this.st
			}
		},
		methods: {

		},
		computed: {
			swiperData() {
				return this.data
			}
		},
		mounted() {
			this.$nextTick(() => {
				var swiper = new Swiper(this.$refs.swiper, {
					direction: this.direction,
					pagination: '.swiper-pagination',
					paginationClickable: true,
					slidesPerView: this.slidesPerView,
					slidesPerGroup: this.slidesPerGroup,
					spaceBetween: this.spaceBetween,
					effect: this.effect,
					autoplay: this.autoPlay,
					mousewheelControl: this.mouse,
					keyboardControl: this.keyboard,
					prevButton: '.swiper-button-prev',
					nextButton: '.swiper-button-next',
				});
			})
		},
	}
</script>
<style type="text/css">
	@import "../../assets/lib/swiper.min.css";
	.swiper-container {
		width: 100%;
		height: 100%;
	}
	
	.swiper-slide {
		text-align: center;
		font-size: 18px;
		background: #fff;
		/* Center slide text vertically */
		display: -webkit-box;
		display: -ms-flexbox;
		display: -webkit-flex;
		display: flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		-webkit-align-items: center;
		align-items: center;
	}
</style>


// WEBPACK FOOTER //
// swiper.vue?a6bfa410